import { useState } from "react";
import { Box, IconButton, Popover } from "@mui/material";
import MenuElement from "./MenuElement";
import { menuOptions } from "./list";
import MenuIcon from "@mui/icons-material/Menu";

const MenuMobile = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const open = Boolean(anchorEl);

  const id = open ? "mobile-menu-popover" : undefined;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MenuIcon sx={{ fontSize: "28px !important" }} />
      </IconButton>

      <Popover
        open={open}
        id={id}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Box sx={{ padding: "0.5rem" }} onClick={handleClose}>
          {menuOptions.map((item, index) => (
            <Box key={`mobileMenuItem_${index}`}>
              <MenuElement
                key={`mobileMenuItem_${index}`}
                id={item.entity}
                label={item.label}
                url={item.link}
                blank={false}
              />
            </Box>
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default MenuMobile;
